import { useQuery } from "@tanstack/react-query";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { getSurveyById } from "../api/getSurvey";

type QueryFnType = typeof getSurveyById;

type UseSurveyOptions = {
  surveyId: number | null; 
  config?: QueryConfig<QueryFnType>;
};

export const useSurvey = ({ surveyId, config = {} }: UseSurveyOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['survey', surveyId],
        queryFn: () => getSurveyById(surveyId!), // el "!" es seguro porque solo se ejecuta si enabled es true
        enabled: !!surveyId,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};